<template>
  <div>
    <div class="header_wrap">
      <div style="width: 60%">
        <el-steps style="width: 100%" align-center :active="0">
          <el-step title="空运信息"></el-step>
          <el-step title="增值服务"></el-step>
          <el-step title="托运信息"></el-step>
          <el-step title="确认委托"></el-step>
          <el-step title="委托完成"></el-step>
        </el-steps>
      </div>
    </div>
    <!-- --------------------------------内容 -->
    <div class="center_wrap" style="padding-bottom: 100px; display: flex">
      <div class="wrap_l" style="margin-right: 10px">
        <div class="Item_list">
          <div class="cangkutit" style="margin-right: 50px">
            <!-- 起运地  -->
            {{ cangkuitem.namec }}
          </div>
          <div class="cangkutit" style="margin-right: 50px">
            <img
              style="width: 55px; padding-top: 5px"
              src="../../assets/airOrder.png"
              alt=""
            />
          </div>
          <div class="cangkutit">
            <!-- 目的地  -->
            {{ PScangkuitem.namec }}
          </div>
        </div>

        <!-- ---上门提货--- -->
        <div class="Item_list">
          <div style="width: 100%">
            <el-checkbox v-model="pickFeeForAir.checked" @change="changeTi"
              >发货地上门提货</el-checkbox
            >
          </div>
          <div style="width: 100%; float: left" v-if="pickFeeForAir.checked">
            <div style="padding: 25px 0 0 25px; box-sizing: border-box">
              <el-form
                label-position="left"
                label-width="80px"
                :model="pickFeeForAir"
              >
                <el-form-item label="提货地点">
                  <div
                    @click="changeCheic()"
                    style="
                      width: 344px;
                      height: 36px;
                      background: #ffffff;
                      border: 1px solid #e7e7e7;
                      border-radius: 5px;
                    "
                  >
                    <span style="float: left"
                      ><i
                        style="font-size: 16px; padding: 0 5px"
                        class="el-icon-location-outline"
                      ></i
                    ></span>
                    <span
                      style="
                        width: 290px;
                        height: 33px;
                        overflow: hidden;
                        display: inline-block;
                      "
                      >{{ pickFeeForAir.parvince }}{{ pickFeeForAir.city
                      }}{{ pickFeeForAir.area
                      }}{{ pickFeeForAir.address }}</span
                    >
                    <span style="float: right"
                      ><i class="el-icon-arrow-right"></i
                    ></span>
                  </div>
                </el-form-item>
                <el-form-item label="提货日期">
                  <div class="block">
                    <el-date-picker
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      style="width: 344px"
                      v-model="pickFeeForAir.pickUpdate"
                      type="date"
                      @change="pickDate"
                      placeholder="选择日期"
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <!-- ---送货上门--- -->
        <div class="Item_list">
          <el-checkbox v-model="sendFeeForAir.checked" @change="changeSh"
            >目的地送货上门</el-checkbox
          >
          <div style="width: 100%; float: left" v-show="sendFeeForAir.checked">
            <div style="padding: 25px 0 0 25px; box-sizing: border-box">
              <el-form
                label-position="left"
                label-width="80px"
                :model="pickFeeForAir"
              >
                <el-form-item label="配送地点">
                  <div
                    @click="showPStable()"
                    style="
                      width: 344px;
                      height: 36px;
                      background: #ffffff;
                      border: 1px solid #e7e7e7;
                      border-radius: 5px;
                    "
                  >
                    <span style="float: left"
                      ><i
                        style="font-size: 16px; padding: 0 5px"
                        class="el-icon-location-outline"
                      ></i
                    ></span>
                    <span
                      style="
                        width: 290px;
                        height: 33px;
                        overflow: hidden;
                        display: inline-block;
                      "
                      >{{ sendFeeForAir.country }}{{ sendFeeForAir.city
                      }}{{ sendFeeForAir.area
                      }}{{ sendFeeForAir.address }}</span
                    >
                    <span style="float: right"
                      ><i class="el-icon-arrow-right"></i
                    ></span>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>

        <!-- ---填写商品信息--- -->
        <div class="demoLIst">
          <el-form
            label-width="78px"
            label-position="left"
            class="demo-dynamic"
            size="mini"
            :model="ruleform"
            ref="ruleform"
          >
            <div
              class="Item_list"
              v-for="(item, index) in ruleform.GoodList"
              :key="index"
            >
              <el-row :gutter="5">
                <el-col :span="12">
                  <el-form-item
                    style="margin: 0"
                    class="rules"
                    label="品名"
                    :prop="'GoodList.' + index + '.goodsname'"
                    :rules="moreNotOjb.goodsNotname"
                  >
                    <div @click="showgoodsType(index)">
                      <el-input readonly v-model="item.goodsname" size="mini">
                        <i slot="suffix" class="el-icon-arrow-right"></i>
                      </el-input>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    class="rules"
                    label="类型"
                    :rules="moreNotOjb.goodsNotname"
                  >
                    <div @click="showgoodsType(index)">
                      <el-input readonly v-model="item.goodstype" size="mini">
                        <i slot="suffix" class="el-icon-arrow-right"></i>
                      </el-input>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    class="rules"
                    label="件数"
                    :prop="'GoodList.' + index + '.piece'"
                    :rules="moreNotOjb.PRiceNotname"
                  >
                    <el-input
                      v-model.number="item.piece"
                      @input="(e) => (item.piece = isSize(e))"
                      size="mini"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    class="rules"
                    label="重量"
                    :prop="'GoodList.' + index + '.weight'"
                    :rules="moreNotOjb.KGNotName"
                  >
                    <el-input
                      size="mini"
                      @change="getHTFcount(), getTimoney(), getPSFcount()"
                      :min="0"
                      :max="999"
                      v-model="item.weight"
                      placeholder="请输入重量"
                    >
                      <i slot="suffix">(KG)</i>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    class="rules"
                    label="体积"
                    :prop="'GoodList.' + index + '.cbm'"
                    :rules="moreNotOjb.CBMNotName"
                  >
                    <el-input
                      size="mini"
                      @change="getHTFcount(), getTimoney(), getPSFcount()"
                      :min="0"
                      :max="999"
                      v-model="item.cbm"
                      placeholder="请输入体积"
                    >
                      <i slot="suffix">(CBM)</i>
                    </el-input>
                    <div
                      v-if="item.heavyUnitPrice != '0'"
                      style="
                        width: 100%;
                        border-radius: 14px;
                        background: #f3eac5;
                        margin-top: 5px;
                      "
                    >
                      <div
                        style="
                          font-size: 22rpx;
                          font-family: PingFang SC;
                          font-weight: 500;
                          color: #9b791e;
                        "
                      >
                        此商品超重,适用重货报价:￥{{ item.heavyUnitPrice }}
                      </div>
                    </div>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-col :span="12">
                    <el-form-item
                      class="rules"
                      label="尺寸(cm)"
                      :prop="'GoodList.' + index + '.l'"
                      :rules="moreNotOjb.CBMNotNameAndLessThen250"
                    >
                      <el-input
                        style="width: 85px"
                        size="mini"
                        v-model.number="item.l"
                        ><i
                          slot="suffix"
                          style="margin-top: 5px; display: inline-block"
                          >长</i
                        >
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item
                      class="rules"
                      label=""
                      label-width="0"
                      :prop="'GoodList.' + index + '.w'"
                      :rules="moreNotOjb.CBMNotNameAndLessThen250"
                    >
                      <el-input
                        style="width: 80px"
                        size="mini"
                        v-model.number="item.w"
                        ><i
                          slot="suffix"
                          style="margin-top: 5px; display: inline-block"
                          >宽</i
                        >
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item
                      class="rules"
                      label=""
                      label-width="0"
                      :prop="'GoodList.' + index + '.h'"
                      :rules="moreNotOjb.CBMNotNameAndLessThen250"
                    >
                      <el-input
                        style="width: 80px"
                        size="mini"
                        v-model.number="item.h"
                        ><i
                          slot="suffix"
                          style="margin-top: 5px; display: inline-block"
                          >高</i
                        >
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
              <div style="width: 100%">
                <el-button
                  v-show="index == ruleform.GoodList.length - 1"
                  type="primary"
                  size="mini"
                  @click="addItem('ruleform')"
                  >+增加更多</el-button
                >
                <el-button
                  icon="el-icon-delete"
                  size="mini"
                  style="background: #eeeeee"
                  v-if="ruleform.GoodList.length > 1"
                  @click="handleDelete(index, item)"
                  >删除</el-button
                >
              </div>
            </div>
          </el-form>
        </div>
        <!-- ---填写商品信息end--- -->
      </div>

      <feeDetail
        :auto_fixed="auto_fixed"
        :allMoreFeeInfo="allMoreFeeInfo"
        :transportFeeForAir="transportFeeForAir"
        :pickFeeForAir="pickFeeForAir"
        :sendFeeForAir="sendFeeForAir"
        :currencyCollection="currencyCollection"
        :calculatePrice="calculatePrice"
        :feeList="feeList"
        @pathToback="pathToback"
        @pathToNext="pathToNext"
      ></feeDetail>
    </div>

    <!-- -----------提货联系人 -->
    <el-dialog
      class="table_wrap"
      title="提货地址"
      :modal-append-to-body="false"
      :visible.sync="dialogFormVisible"
      :SonshowType-val="SonshowType"
    >
      <div class="coutn_show">
        <sonComponents
          @func="getMsgFormSon"
          ref="mychild"
          :contactype2="contactype2"
          :tableData="tableData"
        ></sonComponents>
      </div>
      <div slot="footer" class="dialog-footer header_wrap" style="height: 35px">
        <el-alert title="点击任意一行选择您的地址" type="info" center show-icon>
        </el-alert>
      </div>
    </el-dialog>
    <!-- -----------提货联系人end -->

    <!-- 收货联系人 -->
    <el-dialog title="收货地址" :visible.sync="dialogTableVisible">
      <div
        style="
          width: 100%;
          float: left;
          padding: 15px 15px;
          box-sizing: border-box;
        "
      >
        <div class="addcalss" @click="addbtn()">
          <i
            :class="
              !addType
                ? 'el-icon-circle-plus-outline'
                : 'el-icon-remove-outline'
            "
          ></i>
          {{ !showType ? "添加地址" : "修改地址" }}
        </div>
      </div>

      <el-collapse-transition>
        <div
          class="coutn_show"
          v-show="addType"
          style="width: 100%; float: left"
        >
          <div style="padding: 15px; border: 1px solid #33">
            <div class="Iteminput">
              <div style="min-width: 60px">联系人</div>
              <div style="width: 100%">
                <el-input
                  :maxlength="10"
                  :show-word-limit="true"
                  clearable
                  style="width: 100%"
                  v-model="form.name"
                ></el-input>
              </div>
            </div>

            <div class="Iteminput">
              <div style="min-width: 60px">联系方式</div>
              <div style="width: 100%">
                <el-input
                  :maxlength="13"
                  style="width: 100%"
                  clearable
                  v-model="form.tel"
                ></el-input>
              </div>
            </div>

            <div class="Iteminput">
              <div style="min-width: 60px">联系地址</div>
              <div style="width: 100%">
                <el-cascader
                  style="width: 100%"
                  v-model="shouaddressid"
                  :options="WaicountLIst"
                  :props="defaultParams"
                  @change="handleChange"
                ></el-cascader>
              </div>
            </div>

            <div class="Iteminput">
              <div style="min-width: 60px">详细地址</div>
              <div style="width: 100%">
                <el-input style="width: 100%" v-model="form.address"></el-input>
              </div>
            </div>
          </div>
          <div style="width: 100%; height: 50px; text-align: center">
            <el-button v-show="!showType" type="primary" @click="Qdback('I')"
              >确定</el-button
            >
            <el-button v-show="showType" type="primary" @click="Qdback('U')"
              >修改</el-button
            >
            <el-button
              type="success"
              @click="(addType = false), (showType = false)"
              >取消</el-button
            >
          </div>
        </div>
      </el-collapse-transition>

      <div style="width: 100%; float: left" v-show="!addType">
        <el-table
          height="400"
          tooltip-effect="dark"
          :data="
            PStablelist.filter(
              (data) =>
                !searchPSname ||
                data.name.toLowerCase().includes(searchPSname.toLowerCase())
            )
          "
          highlight-current-row
          border
          ref="Table"
          style="width: 100%; cursor: pointer"
          @row-click="getCurrentRow"
        >
          <el-table-column label="姓名" width="100" align="center" prop="name">
          </el-table-column>
          <el-table-column label="电话" width="120" align="center" prop="tel">
          </el-table-column>
          <el-table-column
            label="联系地址"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.parvince }}
              {{ scope.row.country }}
              {{ scope.row.city }}
              {{ scope.row.area }}
              {{ scope.row.address }}
            </template>
          </el-table-column>
          <el-table-column align="center" width="160">
            <template slot="header" slot-scope="scope">
              <el-input
                v-model="searchPSname"
                size="mini"
                placeholder="请输入姓名"
              />
            </template>
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click.stop="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                size="mini"
                @click.stop="delpsItem(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer header_wrap" style="height: 35px">
        <el-alert title="点击任意一行选择您的地址" type="info" center show-icon>
        </el-alert>
      </div>
    </el-dialog>
    <!-- 收货联系人end -->

    <!-- 菜单 -->
    <el-dialog :visible.sync="goodsTypeShow" class="goodsTypeShow">
      <div style="padding: 30px 0">
        <el-tabs tab-position="left">
          <el-tab-pane
            style="color: red"
            v-for="(item, index) in tabbar"
            :key="index"
            :label="item.namec"
          >
            <div
              style="
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: bold;
                color: #333333;
                margin-bottom: 11px;
              "
            >
              {{ item.namec }}
            </div>
            <div
              v-for="(_item, _index) in item.datItemInfoDTOList"
              :key="_index"
              style="float: left; margin-right: 5px"
            >
              <el-button
                size="mini"
                type="info"
                plain
                @click="changeGoodstype(_item, index)"
                >{{ _item.namec }}</el-button
              >
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import sonComponents from "./userArrdata.vue";
import feeDetail from "./component/fee-detail.vue";
import qs from "qs";
export default {
  components: {
    sonComponents,
    feeDetail,
  },
  data() {
    return {
      // 增值服务上一步后显示
      feeList: [],
      // 增值服务上一步后显示
      allMoreFeeInfo: {
        amount: 0,
        totalExpense: "0",
        feeItemDTOS: [],
      },
      // 运费
      transportFeeForAir: {
        checked: true,
        feeCode: "QBHYF",
        feeType: "Q",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "", //--单价
        cnyamount: "", //现有总价
        amount: "",
        piece: "1",
        price_unit: "",
        goodsTypeFeeDTOS: [],
      },
      // 配送费
      sendFeeForAir: {
        checked: false,
        name: "配送费",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "",
        cnyamount: "",
        amount: "",
        piece: "1",
      },
      //提货费
      pickFeeForAir: {
        checked: false,
        feeCode: "THF",
        price: "",
        currency: "",
        cnyprice: "",
        cnycurrency: "",
        cnyamount: "",
        amount: "",
        piece: 1,
      },
      goodsTypeindex: "",
      tabbar: [],
      goodsTypeShow: false,
      moreNotOjb: {
        PRiceNotname: [
          { required: true, message: "件数不能为空" },
          {
            validator: (rule, value, callback) => {
              if (value.length > 15 || value.length < 1) {
                callback(new Error("长度只能为1-15个字符"));
              } else {
                var reg = /^[1-9]\d*$/;
                if (!reg.test(value)) {
                  callback(new Error("件数不能小于等于0"));
                } else {
                  callback();
                }
              }
            },
            trigger: "change",
          },
        ],
        goodsNotname: [{ required: true, message: "品名不能为空" }],
        KGNotName: [
          { required: true, message: "重量不能为空" },
          {
            validator: (rule, value, callback) => {
              if (value.length > 15 || value.length < 1) {
                callback(new Error("长度只能为1-15个字符"));
              } else {
                var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
                if (!reg.test(value)) {
                  callback(new Error("重量只能大于零且保留最多两位小数"));
                } else {
                  callback();
                }
              }
            },
            trigger: "change",
          },
        ],
        CBMNotName: [
          { required: true, message: "体积不能为空" },
          {
            validator: (rule, value, callback) => {
              if (value.length > 15 || value.length < 1) {
                callback(new Error("长度只能为1-15个字符"));
              } else {
                var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
                if (!reg.test(value)) {
                  callback(new Error("体积只能大于零且保留最多两位小数"));
                } else {
                  callback();
                }
              }
            },
            trigger: "change",
          },
        ],
        // 长宽高大于0小于250校验
        CBMNotNameAndLessThen250: [
          { required: true, message: "请输入" },
          {
            validator: (rule, value, callback) => {
              if (value > 250 || value <= 0) {
                callback(new Error("不能超过250cm或小于0cm"));
              } else {
                // var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
                //     if (!reg.test(value)) {
                //       callback(new Error("只能大于零且小于250cm"));
                //     } else
                //     {
                // 通过
                callback();
                // }
              }
            },
            trigger: "change",
          },
        ],
      },
      SonshowType: true,
      defaultParams: {
        label: "namec",
        value: "namec",
        children: "children",
      },
      shouaddressid: [],
      WaicountLIst: [],
      showType: false,
      addType: false,
      dialogTableVisible: false,
      Timeshow: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      auto_fixed: false,
      cbm: null,
      tableData: [],
      // Citydata: null,
      cangkuitem: null,
      guojiaData: null,
      PStablelist: [],
      searchPSname: "",
      newTihuoarr: "", //需展示的提货地址

      // jack

      ruleform: {
        GoodList: [
          {
            goodsitemid: "",
            goodsname: null, //品名
            goodstype: "",
            goodstypeid: "",
            piece: null, //件数
            weight: null, //重量
            cbm: null, //体积
            heavyUnitPrice: "0",
            l: "", //长
            w: "", //宽
            h: "", //高
            markno: "0", //唛头
          },
        ],
      },
      // jack
      msgFormSon: {},
      contactype2: "",
      dialogFormVisible: false,
      form: {
        country: "",
        city: "",
        area: "",
        address: "",
        customerid: "",
        id: "",
        isdefault: false,
        name: "",
        tag: "",
        tel: "",
      },
      setLIstdata: [],
    };
  },
  watch: {},
  computed: {
    //折合人民币
    calculatePrice() {
      let Totalmoney = 0; //总费用
      let sendFeeForAir = 0; //配送费
      let transportFeeForAir = 0; //海运费
      let THFmoney = 0; //提货费
      transportFeeForAir = this.transportFeeForAir.cnyamount
        ? this.transportFeeForAir.cnyamount
        : 0;
      if (this.sendFeeForAir.checked) {
        //如果有配送费
        sendFeeForAir = this.sendFeeForAir.cnyprice
          ? this.sendFeeForAir.cnyprice
          : 0;
      }
      if (this.pickFeeForAir.checked) {
        //如果有提货费
        THFmoney = this.pickFeeForAir.cnyamount
          ? this.pickFeeForAir.cnyamount
          : 0;
      }

      if (transportFeeForAir) {
        Totalmoney += parseFloat(transportFeeForAir);
      }
      if (sendFeeForAir) {
        Totalmoney += parseFloat(sendFeeForAir);
      }
      if (THFmoney) {
        Totalmoney += parseFloat(THFmoney);
      }
      // 增值服务
      if (this.allMoreFeeInfo.amount > 0) {
        Totalmoney += parseFloat(this.allMoreFeeInfo.amount);
      }

      return Totalmoney.toFixed(2);
    },
    // 获得全部费用的币种
    currencyCollection() {
      let currencyAllIn = {};
      // 提货
      if (this.pickFeeForAir.currency && this.pickFeeForAir.checked) {
        if (currencyAllIn[this.pickFeeForAir.currency] === undefined) {
          currencyAllIn[this.pickFeeForAir.currency] = 0;
          currencyAllIn[this.pickFeeForAir.currency] += parseFloat(
            this.pickFeeForAir.amount
          );
        } else {
          currencyAllIn[this.pickFeeForAir.currency] += parseFloat(
            this.pickFeeForAir.amount
          );
        }
      }
      // 发货
      if (this.sendFeeForAir.currency && this.sendFeeForAir.checked) {
        if (currencyAllIn[this.sendFeeForAir.currency] === undefined) {
          currencyAllIn[this.sendFeeForAir.currency] = 0;
          currencyAllIn[this.sendFeeForAir.currency] += parseFloat(
            this.sendFeeForAir.amount
          );
        } else {
          currencyAllIn[this.sendFeeForAir.currency] += parseFloat(
            this.sendFeeForAir.amount
          );
        }
      }

      // 运费

      if (this.transportFeeForAir.currency) {
        if (currencyAllIn[this.transportFeeForAir.currency] === undefined) {
          currencyAllIn[this.transportFeeForAir.currency] = 0;
          currencyAllIn[this.transportFeeForAir.currency] += parseFloat(
            this.transportFeeForAir.amount
          );
        } else {
          currencyAllIn[this.transportFeeForAir.currency] += parseFloat(
            this.transportFeeForAir.amount
          );
        }
      }

      // 模拟增值服务
      // let temp = [
      //   { amount: 12, currency: "USD" },
      //   { amount: 32, currency: "USD" },
      //   { amount: 32, currency: "HKD" },
      //   { amount: 32, currency: "HKD" },
      // ];

      let temp = this.allMoreFeeInfo.feeItemDTOS;
      temp.forEach((item, index) => {
        if (item.checked) {
          if (currencyAllIn[item.currency] === undefined) {
            currencyAllIn[item.currency] = 0;
            currencyAllIn[item.currency] += item.amount;
          } else {
            currencyAllIn[item.currency] += item.amount;
          }
        }
      });

      let text = "";
      Object.keys(currencyAllIn).forEach((item) => {
        text += item + currencyAllIn[item].toFixed(2) + " + ";
      });

      return text.substring(0, text.length - 2);
    },
  },
  methods: {
    // 菜单方法
    showgoodsType(index) {
      this.goodsTypeShow = true;
      this.goodsTypeindex = index;
    },
    // 菜单方法
    changeGoodstype(item) {
      this.goodsTypeShow = false;
      this.goodsTypeindex; //当前对应的商品
      console.log(item);

      this.ruleform.GoodList[this.goodsTypeindex].goodsname = item.namec;

      this.ruleform.GoodList[this.goodsTypeindex].goodstype = item.goodstype;
      this.ruleform.GoodList[this.goodsTypeindex].goodstypeid =
        item.goodstypeid;
      this.ruleform.GoodList[this.goodsTypeindex].goodsitemid = item.id;

      this.getHTFcount();
    },
    // 联系人
    handleEdit(index, row) {
      //编辑
      this.showType = true;
      this.shouaddressid = [];
      console.log(row);
      this.addType = true;
      this.form.customerid = row.customerid;
      this.form.id = row.id;
      this.form.isdefault = row.isdefault;
      this.form.name = row.name;
      this.form.tag = row.tag;
      this.form.tel = row.tel;
      this.form.country = row.country;
      this.form.city = row.city;
      this.form.area = row.area;
      this.form.address = row.address;
      this.shouaddressid.push(row.country);
      this.shouaddressid.push(row.city);
      this.shouaddressid.push(row.area);
      console.log(this.shouaddressid);
      this.setLIstdata = this.shouaddressid;
    },
    // 删除该联系人
    delpsItem(index, row) {
      let that = this;
      this.$confirm("确定删除该联系人吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.axios
            .post(`/customer/delAddress/${row.id}`)
            .then((res) => {
              if (res.data.code == "200") {
                that.$message({
                  message: res.data.message,
                  type: "success",
                });
                this.getPspletable(); //刷新查询列表
              } else {
                that.$message({
                  message: res.data.message,
                  type: "info",
                });
              }
            })
            .catch((res) => {
              console.log(res);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //  添加收货人
    addbtn() {
      this.showType = false;
      this.addType = !this.addType;
    },
    // 联系人方法新增改
    Qdback(Type) {
      if (Type == "I") {
        this.form.id = "";
      }
      if (this.form.name == "") return this.$message("请输入联系人姓名");
      if (this.form.tel == "") return this.$message("请输入联系人电话");
      if (this.form.setLIstdata == []) return this.$message("请选择省市区");
      if (this.form.address == "") return this.$message("请输入详细地址");
      let that = this;
      let params = {
        customerid: JSON.parse(localStorage.getItem("Authorization"))
          .customerid, //客户id
        id: this.form.id,
        isdefault: this.form.isdefault,
        name: this.form.name,
        tag: "",
        tel: this.form.tel,
        country: this.setLIstdata[0],
        city: this.setLIstdata[1],
        area: this.setLIstdata[2],
        address: this.form.address,
      };
      this.axios
        .post(`/customer/addOrUpdateConsigner`, params)
        .then((res) => {
          if (res.data.code == "200") {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.getPspletable(); //刷新查询列表
            this.form.customerid = "";
            this.form.name = "";
            this.form.tel = "";
            this.form.city = "";
            this.form.address = "";
            this.form.id = "";
            this.form.area = "";
            this.form.country = "";
            this.setLIstdata = [];
            this.shouaddressid = [];
            this.showType = false;
            this.addType = false;
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 联系人end
    handleChange(value) {
      // console.log(value);
      this.setLIstdata = value;
    },

    // 精度加法
    accAdd(arg1, arg2) {
      //加法精度
      var r1, r2, m;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },
    // 校验数字的
    isSize(val) {
      val = val.replace(/[^0-9]/gi, "");
      return val;
    },
    // 提货组件的方法
    hindDing() {
      // console.log("123123");
      this.getTimoney();
      this.dialogFormVisible = false;
    },
    // 派送复选框的change方法
    changeSh() {
      console.log(1);
      // this.sendFeeForAir.checked = !this.sendFeeForAir.checked;
      if (this.sendFeeForAir.checked) {
        this.getPSFcount();
      }
      localStorage.setItem("sendFeeForAir", JSON.stringify(this.sendFeeForAir));
    },
    // 提货复选框的change方法
    changeTi() {
      console.log(2);
      // console.log(this.pickFeeForAir);
      if (this.pickFeeForAir.checked) {
        this.getTimoney();
      }
      localStorage.setItem("pickFeeForAir", JSON.stringify(this.pickFeeForAir));
    },
    // 点击选择配送行选择联系人
    getCurrentRow(row) {
      this.sendFeeForAir = Object.assign(this.sendFeeForAir, row);
      this.dialogTableVisible = false;
      localStorage.setItem("sendFeeForAir", JSON.stringify(this.sendFeeForAir));
      this.getPSFcount(); //重新计算配送费
    },
    //点击获取提货
    getMsgFormSon(data) {
      this.pickFeeForAir = Object.assign(this.pickFeeForAir, data);
      localStorage.setItem("pickFeeForAir", JSON.stringify(this.pickFeeForAir));
    },

    // 下一步
    pathToNext(formName) {
      let flag = false;
      this.$refs[formName].validate((valid) => {
        flag = valid;
      });

      if (!flag) {
        console.log("error submit!!");
        return this.$message("请输入商品完整信息");
      }

      if (this.pickFeeForAir.checked) {
        //如果勾选了提货
        if (!this.pickFeeForAir.tel) return this.$message("请选择上门提货地址");
        if (this.pickFeeForAir.pickUpdate == null)
          return this.$message("请选择上门提货时间");
      } else {
        localStorage.removeItem("countLIst_T");
      }
      localStorage.setItem(
        "GoodListForAir",
        JSON.stringify(this.ruleform.GoodList)
      ); //商品信息
      if (this.sendFeeForAir.checked) {
        //如果勾选了配送
        //校验路线正确
        if (!this.sendFeeForAir.country) return this.$message("请选择送货地址");
        let params = {};
        let that = this;
        params = {
          recgoodsCountry: this.sendFeeForAir.country,
          toWarehouseId: this.PScangkuitem.id,
        };
        this.axios
          .post(
            `/busLcljobsBefore/validateWarehouseCountry`,
            qs.stringify(params)
          )
          .then((res) => {
            if (res.data.code == "200") {
              if (flag) {
                localStorage.setItem(
                  "goodListForair",
                  JSON.stringify(this.ruleform.GoodList)
                ); //海运费

                this.$router.push({
                  name: "AirMoreService",
                });
              }
            } else {
              this.$alert(res.data.message, "错误", {
                confirmButtonText: "确定",
                callback: (action) => {
                  this.$message({
                    type: "info",
                    message: `请重新选择送货上门地址`,
                  });
                },
              });
            }
          })
          .catch((res) => {
            this.$message.info("服务器繁忙");
          });
      } else {
        if (flag) {
          this.$router.push({
            name: "AirMoreService",
          });
        }
      }
    },
    // 上一步
    pathToback() {
      this.$router.go(-1);
    },
    //获取运费
    getHTFcount() {
      this.loadin = true;
      let that = this;
      let itemDTOS = [];
      this.ruleform.GoodList.forEach((item, index) => {
        let goodItem = {
          cbm: 0,
          weight: 0,
          goodsTypeId: "",
        };
        goodItem.cbm = item.cbm;
        goodItem.goodsTypeId = item.goodstypeid;
        goodItem.weight = item.weight;
        itemDTOS.push(goodItem);
      });

      let params = {
        // feeCode: "QBHYF",
        pollandId: JSON.parse(localStorage.getItem("cangkuitem")).id, //起运地id,
        podlandId: JSON.parse(localStorage.getItem("PScangkuitem")).id, //目的地仓库
        customerId: JSON.parse(localStorage.getItem("Authorization"))
          .customerid, //客户id
        itemDTOS: itemDTOS,
      };
      this.axios
        .post(`/KYFee/calAirFeeQuoteInfo`, params)
        .then((res) => {
          console.log(res.data.data);
          if (res.data.code == "200") {
            that.transportFeeForAir.price = res.data.data.price;
            that.transportFeeForAir.currency = res.data.data.currency;
            that.transportFeeForAir.cnyprice = res.data.data.price;

            that.transportFeeForAir.amount = res.data.data.amount;
            that.transportFeeForAir.cnyamount = res.data.data.cnyamount;
            that.transportFeeForAir.goodsTypeFeeDTOS =
              res.data.data.goodsTypeFeeDTOS;
            that.ruleform.GoodList.forEach((item, index) => {
              item.goodstype = res.data.data.itemDTOS[index].goodsTypeName;
              item.heavyUnitPrice =
                res.data.data.itemDTOS[index].heavyUnitPrice;
            });
            localStorage.setItem(
              "transportFeeForAir",
              JSON.stringify(that.transportFeeForAir)
            ); //海运费
          } else {
            that.transportFeeForAir.cnyamount = 0;
            that.transportFeeForAir.amount = 0;
            that.transportFeeForAir.price = "";
            that.transportFeeForAir.currency = "";
            that.transportFeeForAir.cnyprice = "";
            that.transportFeeForAir.goodsTypeFeeDTOS = [];
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    SonchangeShow() {
      this.SonshowType = true;
    },
    SonchangeHide() {
      this.SonshowType = false;
    },
    //获取提货费
    getTimoney() {
      if (!this.pickFeeForAir.tel) {
        return;
      }

      let weight = 0,
        cbm = 0;
      this.ruleform.GoodList.forEach((item, index) => {
        weight += parseFloat(+item.weight);
        cbm += parseFloat(+item.cbm);
      });
      if (!(cbm > 0) || !this.ruleform.GoodList[0].goodsname) {
        // this.$message.info('提货:请先添加商品')
        return;
      }
      let params = {};
      params = {
        province: this.pickFeeForAir.parvince, //省 name
        city: this.pickFeeForAir.city,
        //市 name
        area: this.pickFeeForAir.area, //区 name
        customerId: JSON.parse(localStorage.getItem("Authorization"))
          .customerid, //客户id
        feeCode: "THF",
        inWarehouseId: JSON.parse(localStorage.getItem("cangkuitem")).id,
        weight: weight,
        cbm: cbm,
      };
      this.axios
        .post(`/KYFee/getKYPickUpFee`, params)
        .then((res) => {
          if (res.data.code == "200") {
            console.log(this.pickFeeForAir);

            this.pickFeeForAir.price = res.data.data.price; //价格
            this.pickFeeForAir.currency = res.data.data.currency; //币种
            this.pickFeeForAir.cnyprice = res.data.data.cnyprice; //--隐藏单价
            this.pickFeeForAir.cnycurrency = res.data.data.cnycurrency; //”CNY”--换算币种
            this.pickFeeForAir.cnyamount = res.data.data.cnyprice; //”CNY”--换算币种
            this.pickFeeForAir.amount = res.data.data.price;
            this.pickFeeForAir.minKilometer = res.data.data.minKilometer;
            this.pickFeeForAir.maxKilometer = res.data.data.maxKilometer;
            localStorage.setItem(
              "pickFeeForAir",
              JSON.stringify(this.pickFeeForAir)
            );
          } else {
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    //获取配送费 送货上门
    getPSFcount() {
      if (!this.sendFeeForAir.tel) {
        return;
      }
      let weight = 0,
        cbm = 0;
      this.ruleform.GoodList.forEach((item, index) => {
        weight += parseFloat(+item.weight);
        cbm += parseFloat(+item.cbm);
      });
      if (!(cbm > 0) || !this.ruleform.GoodList[0].goodsname) {
        // this.$message.info('送货:请先添加商品')
        return;
      }
      this.loadin = true;
      let params = {
        cbm: cbm,
        podlandId: this.sendFeeForAir.countryId, //目的国id
        podlandCityId: this.sendFeeForAir.cityId, //目的城市id
        podlandAreaId: this.sendFeeForAir.areaId, //目的仓库id
        toWarehouseId: JSON.parse(localStorage.getItem("PScangkuitem")).id,
      };
      this.axios
        .post(`/KYFee/getKYDeliveryFee`, params)
        .then((res) => {
          // console.log(res);
          this.sendFeeForAir.price = res.data.data.price;
          this.sendFeeForAir.currency = res.data.data.currency; //币种
          this.sendFeeForAir.cnyprice = res.data.data.cnyprice; //单价
          this.sendFeeForAir.amount = res.data.data.price;
          this.sendFeeForAir.cnyamount = res.data.data.price;
          localStorage.setItem(
            "sendFeeForAir",
            JSON.stringify(this.sendFeeForAir)
          );
          // this.sendFeeForAir = JSON.parse(JSON.stringify(this.sendFeeForAir));
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 增加更多商品的校验
    addItem(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleform.GoodList.push({
            goodsitemid: "",
            goodsname: "", //品名
            goodstype: "",
            goodstypeid: "",
            heavyUnitPrice: "0",
            piece: "", //件数
            weight: "", //重量
            cbm: "", //体积
            l: "", //长
            w: "", //宽
            h: "", //高
            markno: "0", //唛头
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除商品
    handleDelete(index) {
      //删除
      this.$confirm("确定删除该商品信息吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.ruleform.GoodList.splice(index, 1);
          this.getHTFcount();
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 获取菜单
    GetgoodsType() {
      let that = this;
      this.axios
        .get(`/filedata/findKYItemCategoryList`)
        .then((res) => {
          if (res.data.code == "200") {
            console.log(res.data.datas);
            that.tabbar = res.data.datas;
          } else {
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    //获取国外地址
    getProvinces() {
      let customerid = JSON.parse(sessionStorage.getItem("Authorization"))
        .customerid;
      this.axios
        .post(`/filedata/findThirdLevelAddress`)
        .then((res) => {
          console.log(res);
          this.WaicountLIst = res.data.datas;
        })
        .catch((res) => {
          console.log(res);
        });
    },

    //点击打开配送地址
    showPStable() {
      this.dialogTableVisible = true;
      this.getPspletable();
    },
    //点击打开提货地址
    changeCheic() {
      this.dialogFormVisible = true;
      this.contactype2 = "T";
    },
    //获取收货地址
    getPspletable() {
      let that = this;
      let customerId = JSON.parse(localStorage.getItem("Authorization"))
        .customerid;
      this.axios
        .get(`/customer/addressListForConsigner/${customerId}`)
        .then((res) => {
          console.log(res);
          if (res.data.code == "200") {
            res.data.datas.forEach((item) => {
              this.$set(item, "changeType", false);
            });
            this.PStablelist = res.data.datas;
          } else {
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    //获取提货联系人
    getPeopletable() {
      let that = this;
      let customerId = JSON.parse(localStorage.getItem("Authorization"))
        .customerid;
      this.axios
        .get(`/customer/addressListForDelivery/${customerId}`)
        .then((res) => {
          if (res.data.code == "200") {
            res.data.datas.forEach((item) => {
              this.$set(item, "changeType", false);
            });
            this.tableData = res.data.datas;
          } else {
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 计算滚动的距离
    onScroll() {
      let scrolled =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 计算A区的高度
      let header_height = null;
      if (document.getElementsByClassName("wrap_R")[0]) {
        header_height = document.getElementsByClassName("wrap_R")[0]
          .offsetHeight;
      }
      if (scrolled >= 100) {
        this.auto_fixed = true;
      } else {
        this.auto_fixed = false;
      }
    },
    // 选提货日期后保存
    pickDate() {
      localStorage.setItem("pickFeeForAir", JSON.stringify(this.pickFeeForAir));
    },
  },
  destroyed() {
    // console.log("destroyed");
  },
  created() {
    // console.log(this.$route.params);
    // console.log("this.$route.params");
    // 起运仓和目的仓
    this.cangkuitem = JSON.parse(localStorage.getItem("cangkuitem"));
    this.PScangkuitem = JSON.parse(localStorage.getItem("PScangkuitem"));

    if (localStorage.getItem("GoodListForAir")) {
      //物品信息
      this.ruleform.GoodList = JSON.parse(
        localStorage.getItem("GoodListForAir")
      );
    }
    // 获取查价时候填写的weight和cbm  ,这里||是因为下一步后又返回 这样cmb会变空
    this.ruleform.GoodList[0].weight =
      this.ruleform.GoodList[0].weight || this.$route.params.weight || "";
    this.ruleform.GoodList[0].cbm =
      this.ruleform.GoodList[0].cbm || this.$route.params.cbm || "";

    // 提货费勾选  // 如果选了就赋值
    if (this.$route.params.pickUp && localStorage.getItem("countLIst_T")) {
      let tempPickUp = JSON.parse(localStorage.getItem("countLIst_T"));
      tempPickUp.checked = this.$route.params.pickUp;
      this.pickFeeForAir = tempPickUp;
    }
    this.pickFeeForAir.checked = this.$route.params.pickUp || false;

    // 配送费勾选
    if (this.$route.params.send && localStorage.getItem("countLIst_C")) {
      let tempAir = JSON.parse(localStorage.getItem("countLIst_C"));
      tempAir.checked = this.$route.params.pickUp;
      this.sendFeeForAir = tempAir;
    }
    this.sendFeeForAir.checked = this.$route.params.send;

    // 优先级低于上面 可以覆盖  解决 增值服务返回后获取问题
    if (localStorage.getItem("sendFeeForAir")) {
      this.sendFeeForAir = JSON.parse(localStorage.getItem("sendFeeForAir"));
    }
    if (localStorage.getItem("pickFeeForAir")) {
      this.pickFeeForAir = JSON.parse(localStorage.getItem("pickFeeForAir"));
    }
    console.log(this.pickFeeForAir);

    // jack 费用显示 返回上一显示用
    if (localStorage.getItem("transportFeeForAir")) {
      //运输费
      this.transportFeeForAir = JSON.parse(
        localStorage.getItem("transportFeeForAir")
      );
    }
    // 派送费
    if (localStorage.getItem("sendFeeForAir")) {
      this.sendFeeForAir = JSON.parse(localStorage.getItem("sendFeeForAir"));
    }
    // 提货费
    if (localStorage.getItem("pickFeeForAir")) {
      this.pickFeeForAir = JSON.parse(localStorage.getItem("pickFeeForAir"));
    }
    // 增值服务
    if (localStorage.getItem("moreFeeListForAir")) {
      this.feeList = JSON.parse(
        localStorage.getItem("moreFeeListForAir")
      ).feeItemDTOS;
      this.allMoreFeeInfo = JSON.parse(
        localStorage.getItem("moreFeeListForAir")
      );
    }
  },
  mounted() {
    // console.log('mounted');
    this.GetgoodsType(); //获取货物类型
    this.getPSFcount(); //配送费
    this.getPeopletable(); //提货通讯录
    this.getPspletable(); //收货通讯录
    this.getHTFcount(); //海运费
    this.getProvinces(); //获取国外地址
    this.getTimoney();
    this.$nextTick(function () {
      //监听滚动
      window.addEventListener("scroll", this.onScroll);
    });
  },
};
</script>
<style scoped>
.fontString {
  font-weight: bold;
}
.auto_fixed {
  position: fixed;
  top: 20px;
  margin-left: 778px;
}
.goodsTypeShow >>> .el-dialog__body {
  padding: 0 !important;
}
.table_wrap >>> .el-dialog__body {
  padding: 0 15px !important;
}
.Item_Right {
  float: left;
}
.Item_Right .tit {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #343434;
}
.littit {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
}
.coutText {
  margin-top: 9px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.Item_Right {
  width: 100%;
  float: left;
  padding: 15px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}
.Iteminput {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  margin-bottom: 15px;
  color: #909399;
}
.center_wrap {
  width: 1098px;
  margin: 0 auto;
}
.Item_list {
  width: 100%;
  float: left;
  padding: 34px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}
.header_wrap {
  width: 100%;
  height: 121px;
  margin-top: 33px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
.wrap_l {
  /* float: left; */
  width: 764px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  padding: 35px;
  box-sizing: border-box;
}
.wrap_R {
  /* float: right; */
  width: 320px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
  /* position: sticky;
  top: 0px; */
}
.cangkutit {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  float: left;
}
.addcalss {
  color: #fff;
  background-color: #5f4aff;
  padding: 9px 15px;
  font-size: 12px;
  border-radius: 3px;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-color: #dcdfe6;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  transition: 0.1s;
  font-weight: 500;
  float: right;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/airOrder/AirCargoIndex.vue